module.exports = __webpack_public_path__ + "img/middle_finger.5861da18.gif";